/**
 * @deprecated These mappers are only used for legacy board items (saved before the
 * row-aware layout algorithm in boardLayoutUtils.js). Legacy items are detected by
 * their column_offset format — if it's a JSON object without a '_spans' key
 * (e.g., {'4': 0, '6': 0}), the item uses this legacy mapping.
 * 
 * New items saved via boardLayoutUtils.js store pre-computed spans for each
 * screen size inside column_offset under the '_spans' key, making these
 * mappers unnecessary for new data.
 * 
 * Do not use in new code — use boardLayoutUtils.js instead.
 */
export const columnSpanToUseMapper = {
    0: {
        "regularScreen": 1,
        "largeScreen": 1
    },
    1: {
        "regularScreen": 1,
        "largeScreen": 2
    },
    2: {
        "regularScreen": 2,
        "largeScreen": 4
    },
    3: {
        "regularScreen": 3,
        "largeScreen": 4
    },
    4: {
        "regularScreen": 4,
        "largeScreen": 6
    },
    5: {
        "regularScreen": 3,
        "largeScreen": 5
    },
    6: {
        "regularScreen": 4,
        "largeScreen": 6
    },
}

/**
 * @deprecated No longer used. The new layout system (boardLayoutUtils.js) stores
 * spans for all screen sizes directly, eliminating the need for a reverse mapper.
 * Kept here only as reference for the original approach.
 */
export const columnSpanToSave = {

    "regularScreen": {
        1: 0,
        2: 2,
        3: 3,
        4: 4,
        5: 4,
        6: 4
    },
    "largeScreen": {
        1: 0,
        2: 1,
        3: 2,
        4: 2,
        5: 5,
        6: 4
    }

}

export const closePortalDefaultTabs = [
    {
        "id": "HOME",
        "label": "Home",
        "name": "Home",
        "isDefault" : true,
        "order" : 1,
        "tabType" : "BOARD",
        "visible" : true
    },
    {
        "id": "AppsLibrary",
        "label": "Application Marketplace",
        "name": "Apps Library",
        "isDefault" : true,
        "order" : 2,
        "tabType" : "APPS",
        "visible" : true
    },
    {
        "id": "TEAM_APPS",
        "label": "My Team's AC Applications",
        "name": "My Team's AC Applications",
        "isDefault" : true,
        "order" : 3,
        "tabType" : "TEAM_APPS",
        "visible" : true
    },
    {
        "id": "EXECUTIVE",
        "label": "Executive",
        "name": "Executive",
        "isDefault" : true,
        "order" : 4,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "REPORTING",
        "label": "Reporting",
        "name": "Reporting",
        "isDefault" : true,
        "order" : 5,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "AI/ML",
        "label": "AI/ML",
        "name": "AI/ML",
        "isDefault" : true,
        "order" : 6,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "JOURNAL ENTRY",
        "label": "Journal Entry",
        "name": "Journal Entry",
        "isDefault" : true,
        "order" : 7,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "ACCOUNT RECONCILIATION",
        "label": "Account Reconciliation",
        "name": "Account Reconciliation",
        "isDefault" : true,
        "order" : 8,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "TRACKERS / DELIVERABLES",
        "label": "Trackers/Deliverables",
        "name": "Trackers/Deliverables",
        "isDefault" : true,
        "order" : 9,
        "tabType" : "LIST",
        "visible" : true
    },
]

export const quillFormFieldModules = { toolbar: [['bold', 'italic', 'underline'], [{ 'size': ['small', false, 'large'] }], ['link']] };
export const quillFormFieldFormats = ['bold', 'italic', 'underline', 'size', 'link'];

export const URL_PATTERN = /^https?:\/\/\S+$/;

export const tabTypes = {
    BOARD : "BOARD",
    LIST : "LIST"
}

export const SANITIZE_ALLOWED_TAGS = ['b', 'i', 'u', 'em', 'strong', 'span', 'p', 'br', 'a'];
export const SANITIZE_ALLOWED_ATTRIBUTES = ['href', 'target', 'rel', 'class'];

export const STATIC_RESOURCES = {
    FIRST_PASS_PRO : "https://bi-central.accounting.amazon.dev/Firstpass",
}

export const URL_RESOURCE_CONFIG = {
    MAGNIFY: {
        label: "Magnify Full URL",
        placeholder: "Provide a valid Magnify URL (https://prod.magnify.fintech.amazon.dev/)",
        validationPrefix: "https://prod.magnify.fintech.amazon.dev/"
    },
    AMAZON_NEWS: {
        label: "Amazon News Full URL",
        placeholder: "Provide a valid Amazon News URL (https://www.aboutamazon.com/)",
        validationPrefix: "https://www.aboutamazon.com/"
    },
    ALLOCATIONS: {
        label: "Allocations Full URL",
        placeholder: "Provide a valid Allocations URL (https://website.prod.iad.spectra.fintech.amazon.dev/)",
        validationPrefix: "https://website.prod.iad.spectra.fintech.amazon.dev/"
    },
    PAYSTATION_CENTRAL: {
        label: "PayStation Central Full URL",
        placeholder: "Provide a valid PayStation Central URL (https://paystation.amazon.dev/)",
        validationPrefix: "https://paystation.amazon.dev/"
    },
    PIPPIN: {
        label: "Pippin Full URL",
        placeholder: "Provide a valid Pippin URL (https://pippin.sara.amazon.dev/)",
        validationPrefix: "https://pippin.sara.amazon.dev/"
    },
    PULSE_SURVEY: {
        label: "Pulse Survey Full URL",
        placeholder: "Provide a valid Pulse Survey URL (https://pulse.aws/survey/)",
        validationPrefix: "https://pulse.aws/survey/"
    },
    REPORT_CENTRAL: {
        label: "Report Central Full URL",
        placeholder: "Provide a valid Report Central URL (https://www.report-central.fintech.amazon.dev/)",
        validationPrefix: "https://www.report-central.fintech.amazon.dev/"
    },
    QUICK_CHAT_AGENT: {
        label: "Quick Chat Agent Full URL",
        placeholder: "Provide a valid Quick Chat Agent URL (https://us-east-1.quicksight.aws.amazon.com/)",
        validationPrefix: "https://us-east-1.quicksight.aws.amazon.com/"
    }
};

export const URL_RESOURCE_TYPES = Object.keys(URL_RESOURCE_CONFIG);

export const ENV_SPECIFIC_RESOURCES = {
    BOFFIN : {
        "alpha" : "https://alpha.bi-central.accounting.amazon.dev/BoffinHome",
        "dev" : "https://beta.bi-central.accounting.amazon.dev/BoffinHome",
        "beta" : "https://beta.bi-central.accounting.amazon.dev/BoffinHome",
        "prod" : "https://bi-central.accounting.amazon.dev/BoffinHome"
    },
    TED : {
        "alpha" : "https://alpha.bi-central.accounting.amazon.dev/TEDHome",
        "dev" : "https://beta.bi-central.accounting.amazon.dev/TEDHome",
        "beta" : "https://beta.bi-central.accounting.amazon.dev/TEDHome",
        "prod" : "https://bi-central.accounting.amazon.dev/TEDHome"
    },
    SEC_CENTRAL : {
        "alpha" : "https://alpha.bi-central.accounting.amazon.dev/CorpReportingHome",
        "dev" : "https://beta.bi-central.accounting.amazon.dev/CorpReportingHome",
        "beta" : "https://beta.bi-central.accounting.amazon.dev/CorpReportingHome",
        "prod" : "https://bi-central.accounting.amazon.dev/CorpReportingHome"
    }
}


/**
 * Team labels that appear in the side navigation as dedicated resource links.
 * These teams are excluded from the team dropdown selector in MyTeamsPage
 * and treated specially in Home.js for homeCPView selection.
 */
export const SIDE_NAV_TEAM_LABELS = [
  'Corporate Reporting',
  'Statutory Close',
  'Journal Entry',
  'Reconciliation',
  'Policy',
  'AC Resources',
  'ATEAM Resources',
];
